var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeliveryProgressActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M6 0c3.3137 0 6 2.6863 6 6s-2.6863 6-6 6-6-2.6863-6-6 2.6863-6 6-6m0 2.5713C4.1064 2.5713 2.5713 4.1064 2.5713 6c0 1.8935 1.5352 3.4287 3.4287 3.4287S9.4287 7.8935 9.4287 6 7.8935 2.5713 6 2.5713M6 4c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8955-2 2-2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryProgressActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delivery-progress-active.19cecacb937986029206530b4760fbf6.svg";